<template>
  <div>
    <section id="hero">
      <v-row no-gutters>
        <v-img :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'" src="../assets/map.png">
          <v-theme-provider dark>
            <v-container fill-height>
              <v-row align="center" class="white--text mx-auto" justify="center">
                <v-col class="white--text text-center" cols="12" tag="h1">
                  <span :class="[
                    $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2',
                  ]" class="font-weight-light">
                    "Where is the bun? Is it small? Extremely."
                  </span>

                  <br />

                  <span :class="[
                    $vuetify.breakpoint.smAndDown ? 'display-3' : 'display-4',
                  ]" class="font-weight-black">
                    BUN ALERT
                  </span>
                </v-col>

                <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo( '#about-me' )">
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section>

    <section id="about-me">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">ABOUT BUN ALERT</h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720">
          Want to get notified every time a bun is spotted? Now with real-time,
          crowd-sourced technology you can! Get notifications of nearby buns.
          Submit pictures, names, and a description of those cute little loaves
          of bread that hop.
        </v-responsive>

        <!-- <v-avatar
            class="elevation-12 mb-12"
            size="128"
          >
            <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
          </v-avatar> -->

        <div></div>

        <v-btn @click="logStoreAnalytic( 'Google' )" style="margin-right: 8px" color="blue"
          href="https://play.google.com/store/apps/details?id=com.refect.bunalert" target="_blank" outlined large>
          <span class="grey--text text--darken-1 font-weight-bold">
            Play Store
          </span>
        </v-btn>

        <v-btn @click="logStoreAnalytic( 'Apple' )" style="margin-left: 8px; margin-right: 8px"
          href="https://apps.apple.com/us/app/id1476545203" target="_blank" color="pink" outlined large>
          <span class="grey--text text--darken-1 font-weight-bold">
            App Store
          </span>
        </v-btn>

        <v-btn @click="logStoreAnalytic( 'Web' )" style="margin-left: 8px" href="https://bun-alert-app.web.app"
          target="_blank" color="purple" outlined large>
          <span class="grey--text text--darken-1 font-weight-bold">
            Web App
          </span>
        </v-btn>
      </v-container>

      <div class="py-12"></div>
    </section>

    <section>
      <v-container class="text-center">
        <v-row class="mx-auto">
          <v-col>
            <v-window show-arrows>
              <v-window-item>
                <v-card flat>
                  <v-tooltip top>
                    <template v-slot:activator=" { on, attrs } ">
                      <v-img src="https://imgs.xkcd.com/comics/bun_alert.png" class="mx-auto" width="500" max-width="100%"
                        v-bind="attrs" v-on="on"></v-img>
                    </template>
                    <span>Since buns range from crepuscular to nocturnal, it's
                      recommended that you enable the scheduled "Do Not Disturb"
                      mode on your phone to avoid being woken by alerts about
                      Night Buns.</span>
                  </v-tooltip>
                </v-card>
              </v-window-item>
              <v-window-item>
                <v-card flat>
                  <v-tooltip bottom>
                    <template v-slot:activator=" { on, attrs } ">
                      <v-img src="https://imgs.xkcd.com/comics/bun.png" class="mx-auto" width="500" max-width="100%"
                        v-bind="attrs" v-on="on"></v-img>
                    </template>
                    <span>If a wild bun is sighted, a nice gesture of respect is to
                      send a 'BUN ALERT' message to friends and family, with
                      photographs documenting the bun's location and rank. If no
                      photographs are possible, emoji may be substituted.</span>
                  </v-tooltip>
                </v-card>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- <section id="recent">
      <v-container fill-height>
        <v-carousel hide-delimiters>
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item.src"
          ></v-carousel-item>
        </v-carousel>
      </v-container>
    </section> -->

    <section id="features" class="grey lighten-3">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">App Reviews</h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col v-for="({ icon, title, text }, i) in features" :key="i" cols="12" md="4">
            <v-card class="py-12 px-4" color="grey lighten-5" flat>
              <v-theme-provider dark>
                <div>
                  <v-avatar color="primary" size="88">
                    <v-icon large v-text="icon"></v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>

              <v-card-title class="justify-center font-weight-black text-uppercase" v-text="title"></v-card-title>

              <v-card-text class="subtitle-1" v-text="text"> </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>

    <section id="stats">
      <v-parallax :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
        src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80">
        <v-container fill-height>
          <v-row class="mx-auto">
            <v-col v-for="[value, title] of stats" :key="title" cols="12" md="3">
              <div class="text-center">
                <div class="display-3 font-weight-black mb-4" v-text="value"></div>

                <div class="title font-weight-regular text-uppercase" v-text="title"></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </section>

    <section id="blog">
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">
          Merch
        </h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col v-for="({ src, text, title, link, button }, i) in articles" :key="i" cols="12" md="4">
            <v-img :src="src" class="mb-4" height="275" max-width="100%"></v-img>

            <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

            <div class="title font-weight-light mb-5" v-text="text"></div>

            <v-btn :href="link" target="_blank" class="ml-n4 font-weight-black" @click="logMerchAnalytic( i )" text
              :disabled="link == null">
              {{ button }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>

    <v-sheet id="contact" color="#333333" dark tag="section" tile>
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">
          Contact Me
        </h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-form ref="form" v-model="valid">
          <v-theme-provider light>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="form.contact.name" flat label="Name" solo></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="form.contact.email" flat label="Email*" :rules="form.rules.emailRules" required
                  solo></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="form.contact.subject" flat label="Subject*" solo></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="form.contact.message" flat label="Message*" solo></v-textarea>
              </v-col>

              <v-col class="mx-auto" cols="auto">
                <v-btn color="accent" x-large :disabled="!valid" :loading="loading" @click="submitMessage">
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-theme-provider>

          <v-snackbar v-model="snackbar" timeout="5000">
            {{ errorMessage }}
          </v-snackbar>
        </v-form>
      </v-container>

      <div class="py-12"></div>
    </v-sheet>
  </div>
</template>

<script>
import { collection, getCountFromServer } from "firebase/firestore";
import { analytics, db } from "../firebase";


export default {
  name: "Home",

  data () {
    return {
      analytics,
      articles: [
        {
          src: "https://firebasestorage.googleapis.com/v0/b/bun-alert.appspot.com/o/landing-page%2Fstandard.png?alt=media&token=3d8efcec-ac61-4f18-803d-2a99178eb770",
          title: "Standard T-Shirt",
          text: "Available in 5 different colors including black, navy, asphalt, baby blue, and dark heather",
          button: "Buy Now",
          link: "https://www.amazon.com/dp/B08CKPGY1J",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/bun-alert.appspot.com/o/landing-page%2Fpremium.png?alt=media&token=ccdf963a-83ec-459e-919c-9c4c77ecdbc3",
          title: "Premium T-Shirt",
          text: "Available in 7 different colors including black, navy, slate, baby blue, dark heather, heather blue, and purple",
          button: "Buy Now",
          link: "https://www.amazon.com/dp/B08CTDMQXY",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/bun-alert.appspot.com/o/landing-page%2Ftank.png?alt=media&token=bea01708-b67d-471d-937b-37740deacb19",
          title: "Tank Top",
          button: "Buy now",
          text: "Available in 7 different colors including black, dark heather, heather gray, navy, neon pink, purple, red, royal, saffire, and white",
          link: "https://www.amazon.com/dp/B08KT3PPD5",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/bun-alert.appspot.com/o/landing-page%2Fpopsocket.png?alt=media&token=4e933693-7af9-45d1-a925-c417b4cac11e",
          title: "PopSocket",
          button: "Buy now",
          text: "Collapsible grip provides a secure hold for easier texting, calling, photos, and selfies.",
          link: "https://www.amazon.com/dp/B08KT1VJ22",
        },
      ],
      features: [
        {
          icon: "mdi-account-group-outline",
          title: "The only social media feed you need",
          text: "Bun Alert delivers exactly what it says it does. Nothing but buns. Big buns, small buns, day buns, night buns, city buns, suburban buns. Every bun you can imagine. All cute little loaves that hop.\n100/10 the best app on my phone. I recommend it to everyone, especially people who complain about Twitter."
        },
        {
          icon: "mdi-account-group-outline",
          title: "Tim Coughlin",
          text: "Love that this is real! Please add the ability to move/edit/delete bun pins that you have created. Also the ability to manually place a bun on the map would be nice for when you are currently not next to the bun, but know they're there. The map showed a bun pin I placed, but no others in the entire world were visible.. bug or feature or bun?",
        },
        {
          icon: "mdi-account-group-outline",
          title: "An Apple User",
          text: "Literally nothing but good vibes. An app to alert you there is a bunny in you area. Nothing but good pictures of the furry little guys. Literally the best app on the App Store.",
        },
        {
          icon: "mdi-account-group-outline",
          title: "Best buns around",
          text: "I like big buns and I cannot lie!",
        },
        {
          icon: "mdi-account-group-outline",
          title: "A Google User",
          text: "Better than Pokémon Go",
        },
        {
          icon: "mdi-account-group-outline",
          title: "Emily CPY",
          text: "So fluffy. Much hop.",
        },
      ],
      bunCount: 0,
      stats: [
        ["5.0", "App Store Rating"],
        ["4.8", "Play Store Rating"],
      ],

      valid: false,
      loading: false,
      snackbar: false,
      errorMessage: null,
      form: {
        contact: {
          name: null,
          email: null,
          subject: null,
          message: null,
        },
        rules: {
          emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
          ],
        },
      },
    };
  },

  created () {
    this.getBunCount().then((count) => {
      this.stats.push([count, "Buns Spotted"]);
      this.stats.push(["100%", "Entertainment Value"],);
    });
  },

  methods: {
    async getBunCount () {
      const bunRef = collection(db, "buns");
      const snapshot = await getCountFromServer(bunRef);
      return snapshot.data().count;
    },

    async submitMessage () {
      this.loading = true;

      try {
        await db.collection("messages").add(this.form.contact);
        this.$refs.form.reset();
      } catch (e) {
        console.error(e);
        this.errorMessage = "Could not submit your request at this time";
        this.snackbar = true;
      }

      this.loading = false;
    },

    logMerchAnalytic (pos) {
      const { title } = this.articles[pos];
      const category = pos === 3 ? "PopSocket" : "Apparel/T-Shirts";
      analytics.logEvent("select_content", {
        content_type: "image",
        content_id: `P${pos}`,
        items: [{ name: title, category: category }],
      });
      console.log("logged analytic event");
    },

    logStoreAnalytic (store) {
      analytics.logEvent("app_store", { name: store });
      console.log("logged analytic event");
    },
  },
};
</script>
